"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = randomId;

var _mathRandom = _interopRequireDefault(require("math-random"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-magic-numbers: ["error", { "ignore": [2, 5, 36] }] */
function randomId() {
  var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  return (0, _mathRandom.default)().toString(36).substr(2, maxLength);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9VdGlscy9yYW5kb21JZC5qcyJdLCJuYW1lcyI6WyJyYW5kb21JZCIsIm1heExlbmd0aCIsInRvU3RyaW5nIiwic3Vic3RyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRUE7Ozs7QUFGQTtBQUllLFNBQVNBLFFBQVQsR0FBaUM7QUFBQSxNQUFmQyxTQUFlLHVFQUFILENBQUc7QUFDOUMsU0FBTywyQkFBU0MsUUFBVCxDQUFrQixFQUFsQixFQUFzQkMsTUFBdEIsQ0FBNkIsQ0FBN0IsRUFBZ0NGLFNBQWhDLENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50IG5vLW1hZ2ljLW51bWJlcnM6IFtcImVycm9yXCIsIHsgXCJpZ25vcmVcIjogWzIsIDUsIDM2XSB9XSAqL1xuXG5pbXBvcnQgcmFuZG9tIGZyb20gJ21hdGgtcmFuZG9tJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gcmFuZG9tSWQobWF4TGVuZ3RoID0gNSkge1xuICByZXR1cm4gcmFuZG9tKCkudG9TdHJpbmcoMzYpLnN1YnN0cigyLCBtYXhMZW5ndGgpO1xufVxuIl19